<template>
  <div>
    <h1>QR Registration</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Registration By Date Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Registration by Date</h5>
      <registration-by-date
        :filterUrl="filterUrl"
      ></registration-by-date>
    </div>
    <!-- Registration By Date End -->

    <!-- Registration By Hour Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Registration by Hour</h5>
      <registration-by-hour
        :filterUrl="filterUrl"
      ></registration-by-hour>
    </div>
    <!-- Registration By Hour End -->

    <!-- Registration By Vehicle Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Registration by Vehicle Category</h5>
      <registration-by-vehicle-category
        :filterUrl="filterUrl"
      ></registration-by-vehicle-category>
    </div>
    <!-- Registration By Vehicle Category End -->

    <!-- Registration By Vehicle Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Customer With Identifications</h5>
      <customer-with-identifications
        :filterUrl="filterUrl"
      ></customer-with-identifications>
    </div>
    <!-- Registration By Vehicle Category End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import registrationByDate from './children/registrationByDate'
  import registrationByHour from './children/registrationByHour'
  import registrationByVehicleCategory from './children/registrationByVehicleCategory'
  import customerWithIdentifications from './children/customerWithIdentifications'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      registrationByDate,
      registrationByHour,
      registrationByVehicleCategory,
      customerWithIdentifications,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>